export default {
    originalEmail: {
        en: 'Original email',
        sk: 'Pôvodný email',
        cz: 'Původní email',
        de: 'Ursprüngliche E-Mail',
    },
};
